import type { PendingFundingSourceKind } from "./types";

export const MAX_REIMBURSEMENT_BATCH = 50;

export function parseReimbursementBatch(payload: Record<string, unknown>) {
  const operationId = String(payload.operacionId ?? "");
  if (!/^[a-zA-Z0-9_-]{1,150}$/.test(operationId)) throw new Error("Falta un identificador válido para esta selección.");
  const source = String(payload.fuente ?? "") as PendingFundingSourceKind;
  if (!["new", "week", "savings", "fund"].includes(source)) throw new Error("Elige el origen de los reembolsos.");
  const sourceId = String(payload.fuenteId ?? "");
  if ((source === "week" || source === "fund") && (!sourceId || sourceId.includes("/"))) throw new Error("Elige una fuente válida.");
  if (!Array.isArray(payload.items) || !payload.items.length || payload.items.length > MAX_REIMBURSEMENT_BATCH) throw new Error(`Selecciona entre 1 y ${MAX_REIMBURSEMENT_BATCH} reembolsos.`);
  const items = payload.items.map((item: unknown) => {
    if (!item || typeof item !== "object") throw new Error("La selección no es válida.");
    const { movementId, amountCents } = item as Record<string, unknown>;
    if (typeof movementId !== "string" || !movementId || movementId.includes("/") || typeof amountCents !== "number" || !Number.isSafeInteger(amountCents) || amountCents <= 0) throw new Error("La selección contiene un reembolso inválido.");
    return { movementId, amountCents };
  }).sort((a, b) => a.movementId.localeCompare(b.movementId));
  if (new Set(items.map(item => item.movementId)).size !== items.length) throw new Error("Un reembolso aparece más de una vez.");
  if (!Number.isSafeInteger(items.reduce((sum, item) => sum + item.amountCents, 0))) throw new Error("El total de reembolsos no es válido.");
  return { operationId, source, sourceId, items };
}
